export default __webpack_public_path__ + "static/lab-visit-male-8aeb9c9c1414651d96a094563517d897.jpg";